module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/full-print/3-8c24a99707b28337c26eacae057c354b.jpg";